import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Stack, Fade } from "@mui/material";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { useNavigate } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import "./GetStarted.css";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { headingFonts, mainButtonStyles } from "../../Styles/Styles";

export default function GetStarted() {
  const headings = [
    "Discover. Connect. Trade.",
    "Buy & Sell with Ease.",
    "Start Your Journey Today.",
  ];

  const subheadings = [
    "Find everything you need in one place.",
    "Seamless transactions in the Cayman Islands.",
    "Join a growing marketplace of buyers & sellers.",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showTyping, setShowTyping] = useState(true);
  const [view, setView] = useState("buttons"); // 'buttons', 'login', 'register'
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setShowTyping(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % headings.length);
        setShowTyping(true);
      }, 1000);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box className="fullscreen">
      <Box className="get-started-container">
        {/* Left Section - Animated Text */}
        <Box className="text-section">
          <Typography
            variant="h3"
            className="animated-text"
            sx={{ ...headingFonts }}
          >
            {showTyping ? (
              <Typewriter
                words={[headings[currentIndex]]}
                typeSpeed={60}
                deleteSpeed={30}
              />
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="h6" className="subtext" sx={{ ...headingFonts }}>
            {showTyping ? (
              <Typewriter
                words={[subheadings[currentIndex]]}
                typeSpeed={50}
                deleteSpeed={25}
              />
            ) : (
              ""
            )}
          </Typography>
        </Box>

        {/* Right Section - Buttons or Login Form */}
        <Box
          className="button-section"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {view === "buttons" ? (
            <Fade in timeout={500}>
              <Stack spacing={2} alignItems="center" width="100%">
                {/* Button Row */}
                <Stack direction="row" spacing={2} justifyContent="center">
                  <Button
                    className="main-button-style"
                    onClick={() => setView("login")}
                    sx={{ ...mainButtonStyles }}
                  >
                    <span>LOG IN</span>
                    <span>
                      <LoginOutlinedIcon fontSize="small" />
                    </span>
                  </Button>

                  <Button
                    className="main-button-style"
                    onClick={() => setView("register")}
                    sx={{ ...mainButtonStyles }}
                  >
                    <span>Register</span>
                    <span>
                      <PersonAddAltOutlinedIcon fontSize="small" />
                    </span>
                  </Button>
                </Stack>

                {/* Back to Home Text */}
                <Typography
                  variant="body1"
                  sx={{
                    marginTop: "10px",
                    cursor: "pointer",
                    color: "var(--primary-color)",
                    fontFamily: "ClashGrotesk-Medium",
                    textDecoration: "none",
                    "&:hover": { opacity: 0.8 },
                  }}
                  onClick={() => navigate("/")}
                >
                  Back to Home
                </Typography>
              </Stack>
            </Fade>
          ) : (
            <Fade in timeout={500}>
              <Box width="100%" display="flex" justifyContent="center">
                {view === "login" && (
                  <LoginForm
                    onClose={(nextView) => setView(nextView || "buttons")}
                  />
                )}
                {view === "register" && (
                  <RegisterForm
                    onClose={(nextView) => setView(nextView || "buttons")}
                  />
                )}
                {view === "forgot-password" && (
                  <ForgotPasswordForm
                    onClose={(nextView) => setView(nextView || "buttons")}
                  />
                )}
              </Box>
            </Fade>
          )}
        </Box>
      </Box>
    </Box>
  );
}
